/**
 * Asynchronously loads the component
 */
import Loadable from 'react-loadable';

import PropertiesPageSkeleton from 'app/shared/components/skeletons/PropertiesPageSkeleton';

export default Loadable({
    loader: () => import('./index'),
    loading: PropertiesPageSkeleton,
});
